import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, map } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogData } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  open(data: ConfirmDialogData): Observable<boolean> {
    return this.dialog
      .open(ConfirmDialogComponent, {
        data,
        width: '460px',
        maxWidth: '92vw',
        panelClass: 'confirm-dialog-container',
        disableClose: true,
        autoFocus: true,
        restoreFocus: true,
        enterAnimationDuration: 0,
        exitAnimationDuration: 0,
      })
      .afterClosed()
      .pipe(map((result) => !!result));
  }
}
